import React, { useState, useEffect } from 'react';
import styled from 'styled-components'
import { useTable, usePagination, useSortBy, useFilters, useGroupBy, useExpanded, useRowSelect, } from 'react-table';
import { primeJSONLocation } from '../shared/baseUrl';
import { emptyPrime } from '../shared/emptyPrime';
import { greaterThanFunction, typeFilterFunction, includeFilterFunction} from '../services/filters';
import { CellImage, getActionColor, getBackgroundColor, getFontWeight} from '../services/cellDecoration';
import * as helper_functions from '../services/helper_functions';

const Styles = styled.div`
  
  overflow-x: auto;
  padding: 1rem;

  table {
    border-spacing: 0;
    border: 1px solid black;
    width: 650px;
    table-layout:fixed;

    tr {
      :last-child {
        td {
          border-bottom: 0;
        }
      }
    }

    th,
     
    td {
      margin: 0;
      padding: 0.5rem;
      border-bottom: 1px solid black;
      border-right: 1px solid black;
      overflow: hidden;
      text-overflow: ellipsis;  

      :last-child {
        border-right: 0;
      }
    }

  }

  .pagination {
    padding: 0.5rem;
  }
`
// Be sure to pass our updateMyData and the skipReset option
function Table({ columns, data}) {

    // Use the state and functions returned from useTable to build your UI
    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        prepareRow,
        page, // Instead of using 'rows', we'll use page,
        // which has only the rows for the active page

        // The rest of these things are super handy, too ;)
        canPreviousPage,
        canNextPage,
        pageOptions,
        pageCount,
        gotoPage,
        nextPage,
        previousPage,
        setPageSize,
        setFilter,
        state: {
            pageIndex,
            pageSize,
        },
    } = useTable(
        {
            columns,
            data,
        },
        useFilters,
        useGroupBy,
        useSortBy,
        useExpanded,
        usePagination,
        useRowSelect
    )

     // Render the UI for your table
    return (
        <>
            <div className="container">
                <div className="row">
                    <table striped bordered hover size="sm" {...getTableProps()}>
                        <thead>
                            {headerGroups.map(headerGroup => (
                                <tr {...headerGroup.getHeaderGroupProps()}>
                                    {headerGroup.headers.map(column => (
                                        <th {...column.getHeaderProps({
                                            style: { maxWidth: column.maxWidth, width: column.width, height: 65 },
                                        })}>
                                            {column.render("Header")}
                                        </th>
                                    ))}
                                </tr>
                            ))}
                        </thead>
                        <tbody {...getTableBodyProps()}>
                            {page.map(row => {
                                prepareRow(row)
                                return (
                                    <tr {...row.getRowProps()}
                                        style={{
                                            background: getBackgroundColor(row.cells[1].value)
                                        }}>
                                        {console.log(row.cells[1].value)}
                                        {row.cells.map(cell => {
                                            return (
                                                <td {...cell.getCellProps()}
                                                    style={{
                                                        color: getActionColor({ cell }),
                                                        fontWeight: getFontWeight({ cell }),
                                                    }}
                                                >
                                                    <CellImage cell={cell} />
                                                    {cell.render("Cell")}
                                                </td>
                                            )
                                        })}
                                    </tr>
                                )
                            })}
                        </tbody>
                    </table>
                </div>
            </div>
            {/*Pagination*/}
            <div className="container">
                <div className="row">
                    <div className="col-12 col-sm-3 me-auto mt-3">
                        <button type="button" class="btn btn-primary btn-sm" onClick={() => gotoPage(0)} disabled={!canPreviousPage}>
                            {'<<'}
                        </button>{' '}
                        <button type="button" class="btn btn-primary btn-sm" onClick={() => previousPage()} disabled={!canPreviousPage}>
                            {'<'}
                        </button>{' '}
                        <button type="button" class="btn btn-primary btn-sm" onClick={() => nextPage()} disabled={!canNextPage}>
                            {'>'}
                        </button>{' '}
                        <button type="button" class="btn btn-primary btn-sm" onClick={() => gotoPage(pageCount - 1)} disabled={!canNextPage}>
                            {'>>'}
                        </button>{' '}
                        <span>
                            Page{' '}
                            <strong>
                                {pageIndex + 1} of {pageOptions.length}
                            </strong>{' '}
                        </span>
                    </div>
                    <div className='col-6 col-sm-2 me-auto mt-3'>
                        <div class="input-group input-group-sm">
                            <span class="input-group-text" id="inputGroup-sizing-sm">Go to page:</span>
                            <input
                                type="number"
                                defaultValue={pageIndex + 1}
                                onChange={e => {
                                    const page = e.target.value ? Number(e.target.value) - 1 : 0
                                    gotoPage(page)
                                }}
                                class="form-control" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" />
                        </div>
                    </div>
                    <div className='col-6 col-sm-2 me-auto mt-3'>
                        <select class="form-select form-select-sm" aria-label=".form-select-sm example"
                            value={pageSize}
                            onChange={e => {
                                setPageSize(Number(e.target.value))
                            }}
                        >
                            {[10, 20, 30, 40, 50].map(pageSize => (
                                <option key={pageSize} value={pageSize}>
                                    Show {pageSize}
                                </option>
                            ))}
                        </select>
                    </div>
                    <div className="col-5 d-none d-lg-block mt-3"></div>
                </div>
            </div>
        </>
    )
}

function Prime() {
    const columns = React.useMemo(
        () => [
            {
                //Header: 'Action',
                Header: () => (
                    <div
                      style={{
                        textAlign:"center"
                      }}
                    >mint date</div>),                 
                accessor: 'eligible_time',
                maxWidth: 50,
                //filter: typeFilterFunction
            },
            {
                //Header: 'USD',
                Header: () => (
                    <div
                      style={{
                        textAlign:"center"
                      }}
                    >staked XVS</div>),
                accessor: 'staked',
                maxWidth: 35,
                //filter: greaterThanFunction
            },
            {
                //Header: 'txtime',
                Header: () => (
                    <div
                      style={{
                        textAlign:"center"
                      }}
                    >address</div>),                     
                accessor: 'addr',
                maxWidth: 140,
                Cell: props => <a href={`https://debank.com/profile/${props.value}`} target="_blank">{props.value}</a>,                
            },            
        ],

        []
    )

    const [data, setData] = React.useState(emptyPrime);

    //fill table from whales json-file
    useEffect(() => {
        const fetchData = async () => {
            const primeMembers = await fetch(primeJSONLocation)
                .then((response) => response.json());

            primeMembers.sort((a, b) => b.txtime - a.txtime);

            for (let primeMember of primeMembers) {
                primeMember.eligible_time = helper_functions.formatDate(primeMember.eligible_time);
            }

            setData(primeMembers);
        };

        fetchData();
    }, []);


    // We need to keep the table from resetting the pageIndex when we
    // Update data. So we can keep track of that flag with a ref.
    const skipResetRef = React.useRef(false)

    // When our cell renderer calls updateMyData, we'll use
    // the rowIndex, columnId and new value to update the
    // original data
    const updateMyData = (rowIndex, columnId, value) => {
        // We also turn on the flag to not reset the page
        skipResetRef.current = true
        setData(old =>
            old.map((row, index) => {
                if (index === rowIndex) {
                    return {
                        ...row,
                        [columnId]: value,
                    }
                }
                return row
            })
        )
    }

    // After data changes, we turn the flag back off
    // so that if data actually changes when we're not
    // editing it, the page is reset
    React.useEffect(() => {
        skipResetRef.current = false
    }, [data])

    return (
        <Styles>
            <div className="container">
                <div className='row'>
                    <div className='col-12 col-sm-6 mt-2 mb-4'>
                        <p class="text-center">
                            <h2>Expected Primes</h2>
                        </p>
                    </div>
                </div>
            </div>
            <Table
                columns={columns}
                data={data}
                updateMyData={updateMyData}
                skipReset={skipResetRef.current}
            />
        </Styles >
    )
}

export default Prime